import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Header from "../../AdminHeader";
import AttendanceReport from "./AttendanceReport";

/**
 * MN-2075: the admin Reports hub. Deliberately generic - report #2 is a new entry in
 * AVAILABLE_REPORTS plus its own body component, nothing else changes here.
 */
const AVAILABLE_REPORTS = [
  {
    key: "attendance",
    name: "Attendance Report",
    description:
      "Members who attended a set of classes - pick classes by course, or search classes directly.",
    component: AttendanceReport,
  },
];

export class ReportsMainPage extends Component {
  state = {
    selectedReportKey: AVAILABLE_REPORTS[0].key,
  };

  selectReport = (key) => {
    this.setState({ selectedReportKey: key });
  };

  render() {
    let { selectedReportKey } = this.state;
    let selectedReport = AVAILABLE_REPORTS.find(
      (r) => r.key === selectedReportKey
    );
    let ReportBody = selectedReport ? selectedReport.component : null;

    return (
      <>
        <Header />
        <div className="fet-container container-fluid">
          <br />
          <div className="card directory-card border-rounded shadow mt-4">
            <h5 className="card-header mt-0 px-3 py-1">Reports</h5>
            <div className="card-body pb-2 pt-3">
              <div className="row">
                <div className="col-md-3">
                  <div className="list-group">
                    {AVAILABLE_REPORTS.map((report) => {
                      let isSelected = report.key === selectedReportKey;
                      return (
                        <a
                          key={report.key}
                          className="list-group-item list-group-item-action c-pointer"
                          // Bootstrap's .active paints a solid blue that the dark title and
                          // muted <small> description are unreadable on. A light tint plus an
                          // accent bar marks the selection while keeping text contrast.
                          style={{
                            backgroundColor: isSelected ? "#eef5ff" : "#fff",
                            borderLeft: isSelected
                              ? "3px solid #2f6fd0"
                              : "3px solid transparent",
                          }}
                          onClick={() => this.selectReport(report.key)}
                        >
                          <div
                            className="font-weight-bold"
                            style={{ color: isSelected ? "#1b4f9c" : "#212529" }}
                          >
                            {report.name}
                          </div>
                          <small style={{ color: "#6c757d" }}>
                            {report.description}
                          </small>
                        </a>
                      );
                    })}
                  </div>
                </div>
                <div className="col-md-9">
                  {ReportBody ? (
                    <ReportBody />
                  ) : (
                    <div className="text-muted">Select a report.</div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(ReportsMainPage);
